import React from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import Blog2 from '../Components/img/stress.jpeg'; // Using the image from the blog

const ManagingStress = () => {
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col md={6}>
        <h2 className="text-dark">Managing Stress Effectively</h2>
          <p className="text-muted">
            Stress is a common part of life, but managing it effectively is essential for **mental clarity** and **emotional well-being**. 
            Practicing healthy coping mechanisms can help prevent **burnout, anxiety, and physical health issues**.
          </p>
          <p className="text-muted">
            Effective stress management improves **productivity, decision-making**, and overall **happiness**. 
            Adopting the right strategies can bring balance and peace into your daily routine.
          </p>
          <Image src={Blog2} alt="Managing Stress" fluid className="rounded shadow" />
        </Col>
        <Col md={6}>
        

          <h5 className="text-dark mt-4"> Tips for Managing Stress:</h5>
          <ListGroup variant="flush" className="mt-3">
            <ListGroup.Item>✅ <strong>Practice Deep Breathing:</strong> Helps calm the nervous system and reduces stress.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Engage in Physical Activities:</strong> Exercise releases endorphins that boost mood.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Follow a Healthy Diet:</strong> Nutritious food supports mental and physical health.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Maintain a Balanced Routine:</strong> Proper time management helps reduce unnecessary stress.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Take Breaks & Relax:</strong> Short breaks improve focus and prevent burnout.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Seek Support When Needed:</strong> Talking to a friend, family member, or therapist can be beneficial.</ListGroup.Item>
          </ListGroup>

          <p className="text-muted mt-3">
            By incorporating these simple yet effective strategies, you can **build resilience**, maintain a **positive mindset**, 
            and achieve greater emotional stability in daily life.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default ManagingStress;
